/* CLOWN refonte v2 · fiches produit. Galerie, kit, Duo (2e kit), lecteur, barre fixe, ajout panier.
   L'ajout passe par l'événement global clown:cart:add (clown-refonte.js) : tiroir et compteur restent gérés là-bas. */
(() => {
  'use strict';
  const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;

  const init = (root) => {
    if (root.dataset.crInitialized) return;
    root.dataset.crInitialized = 'true';
    const abort = new AbortController();
    const signal = abort.signal;
    let data;
    try { data = JSON.parse(root.querySelector('[data-cr-product-data]').textContent); } catch { return; }
    const mainForm = root.querySelector('[data-cr-main-form]');
    if (!mainForm) return;
    const variantInput = mainForm.querySelector('[data-cr-variant-input]');
    const duoInput = mainForm.querySelector('[data-cr-duo]');
    // Même format que le filtre Liquid « money » de la boutique (déduit d'un échantillon rendu côté serveur).
    const fmt = (() => {
      const m = String(data.moneySample || '').match(/^(.*?)1(\D?)234(?:(\D)56)?(.*)$/);
      return m ? { pre: m[1], th: m[2], dec: m[3] || '', post: m[4], digits: m[3] ? 2 : 0 } : null;
    })();
    const money = (cents) => {
      if (!fmt) return new Intl.NumberFormat(data.locale || 'fr', { style: 'currency', currency: data.currency || 'EUR' }).format(cents / 100);
      const [int, frac] = (cents / 100).toFixed(fmt.digits).split('.');
      return fmt.pre + int.replace(/\B(?=(\d{3})+(?!\d))/g, fmt.th) + (frac ? fmt.dec + frac : '') + fmt.post;
    };
    let activeKit = 'current';
    const selected = {
      current: Number(variantInput.value),
      complete: data.complete?.variants.find(v => v.available)?.id || data.complete?.variants[0]?.id,
    };
    const getVariant = () => data[activeKit]?.variants.find(v => v.id === selected[activeKit]) || data[activeKit]?.variants[0];
    const getQuantity = () => Number(mainForm.querySelector('input[name="quantity"]:checked')?.value || mainForm.querySelector('input[type="hidden"][name="quantity"]')?.value || 1);

    /* ---------- Galerie ---------- */
    const medias = [...root.querySelectorAll('[data-cr-media]')];
    const thumbs = [...root.querySelectorAll('[data-cr-thumb]')];
    const dots = [...root.querySelectorAll('.cr-pdp__dots span')];
    let current = Math.max(0, medias.findIndex(el => !el.hidden));
    const showIndex = (index) => {
      if (!medias.length) return;
      current = (index + medias.length) % medias.length;
      medias.forEach((el, i) => {
        const on = i === current;
        el.hidden = !on;
        if (!on) el.querySelectorAll('video').forEach(v => v.pause());
      });
      thumbs.forEach((t, i) => t.setAttribute('aria-pressed', String(i === current)));
      dots.forEach((d, i) => d.classList.toggle('is-on', i === current));
      const active = thumbs[current];
      if (active && active.parentElement.scrollWidth > active.parentElement.clientWidth) {
        active.parentElement.scrollTo({ left: active.offsetLeft - 20, behavior: reduced() ? 'auto' : 'smooth' });
      }
    };
    const showMedia = (id) => { const i = medias.findIndex(el => el.dataset.crMedia === String(id)); if (i >= 0) showIndex(i); };
    thumbs.forEach((button, i) => button.addEventListener('click', () => showIndex(i), { signal }));
    const stage = root.querySelector('[data-cr-stage]');
    if (stage && medias.length > 1) {
      let startX = null; let startY = 0;
      stage.addEventListener('pointerdown', e => { if (e.pointerType !== 'mouse') { startX = e.clientX; startY = e.clientY; } }, { signal });
      stage.addEventListener('pointerup', e => {
        if (startX === null) return;
        const dx = e.clientX - startX; const dy = e.clientY - startY; startX = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { stage.dataset.crSwiped = 'true'; showIndex(current + (dx < 0 ? 1 : -1)); }
      }, { signal });
      stage.addEventListener('keydown', e => {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); showIndex(current + (e.key === 'ArrowRight' ? 1 : -1)); }
      }, { signal });
    }

    /* ---------- Synchronisation prix / variante ---------- */
    const sync = () => {
      const variant = getVariant();
      if (!variant) return;
      variantInput.value = variant.id;
      const limited = variant.inventoryManagement && variant.inventoryPolicy !== 'continue';
      if (duoInput) {
        duoInput.disabled = limited && variant.inventoryQuantity < 2;
        if (duoInput.disabled) duoInput.checked = false;
      }
      const quantity = getQuantity();
      // Shopify arrondit la remise réelle à l'entier inférieur (EUR vérifié : 1 999 centimes).
      // La remise Duo porte sur un seul 2e kit par commande.
      const duoSaving = root.dataset.mode === 'complete' ? Math.floor(variant.price * Number(data.duoPercent || 0) / 100) : 0;
      const total = variant.price * quantity - (quantity > 1 ? duoSaving : 0);
      root.querySelectorAll('[data-cr-total-price]').forEach(el => { el.textContent = money(total); });
      root.querySelectorAll('[data-cr-duo-second]').forEach(el => { el.textContent = money(variant.price - duoSaving); });
      root.querySelectorAll('[data-cr-total-note]').forEach(el => { el.textContent = quantity > 1 ? el.dataset.two : el.dataset.one; });
      const savingNote = root.querySelector('[data-cr-duo-saving]');
      if (savingNote) savingNote.hidden = quantity < 2 || !duoSaving;
      root.querySelectorAll('[data-cr-duo-amount]').forEach(el => { el.textContent = money(duoSaving); });
      root.querySelectorAll('[data-cr-unit-price]').forEach(el => { el.textContent = variant.money; });
      root.querySelectorAll('[data-cr-submit]').forEach(button => { button.disabled = !variant.available; });
      const single = root.dataset.mode === 'single' && !root.hasAttribute('data-kit-choice');
      root.querySelectorAll('[data-cr-atc-label]').forEach(el => {
        el.textContent = !variant.available ? window.clownI18n.message_16 : single ? window.clownI18n.message_17 : activeKit === 'complete' ? window.clownI18n.message_18 : quantity > 1 ? window.clownI18n.message_19 : window.clownI18n.message_20;
      });
      root.querySelectorAll('[data-cr-sticky-label]').forEach(el => { el.textContent = !variant.available ? window.clownI18n.message_16 : quantity > 1 ? window.clownI18n.message_21 : window.clownI18n.message_22; });
      root.querySelectorAll('[data-cr-sticky-title]').forEach(el => { el.textContent = (quantity > 1 ? '2 × ' : '') + data[activeKit].title; });
      const unlock = root.querySelector('[data-cr-unlock]');
      if (unlock) {
        const on = activeKit === 'complete';
        unlock.classList.toggle('is-unlocked', on);
        unlock.querySelectorAll('[data-locked]').forEach(el => { el.textContent = on ? el.dataset.unlocked : el.dataset.locked; });
      }
      root.querySelectorAll('[data-cr-duo-label]').forEach(el => { el.textContent = quantity > 1 ? el.dataset.on : el.dataset.off; });
      const currentSel = root.querySelector('[data-cr-current-variants]');
      const completeSel = root.querySelector('[data-cr-complete-variants]');
      if (currentSel) currentSel.hidden = activeKit !== 'current';
      if (completeSel) completeSel.hidden = activeKit !== 'complete';
      if (activeKit === 'current' && variant.mediaId) showMedia(variant.mediaId);
      if (activeKit === 'current' && data.current.variants.length > 1) {
        const url = new URL(location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState(history.state, '', url);
      }
      const status = mainForm.querySelector('[data-cr-form-status]');
      if (status) { status.textContent = ''; status.classList.remove('is-error'); }
    };
    root.querySelectorAll('[data-cr-kit]').forEach(input => input.addEventListener('change', () => { activeKit = input.value; sync(); }, { signal }));
    root.querySelectorAll('[data-cr-variant-select]').forEach(select => select.addEventListener('change', () => { selected[select.dataset.crVariantSelect] = Number(select.value); sync(); }, { signal }));
    duoInput?.addEventListener('change', sync, { signal });
    root.querySelectorAll('[data-cr-pick-complete]').forEach(button => button.addEventListener('click', () => {
      const input = root.querySelector('[data-cr-kit][value="complete"]');
      if (!input || input.disabled) return;
      input.checked = true; activeKit = 'complete'; sync();
      input.closest('fieldset').scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'center' });
      input.focus({ preventScroll: true });
    }, { signal }));

    /* ---------- Ajout au panier (tous les formulaires de la fiche) ---------- */
    root.querySelectorAll('[data-cr-form]').forEach(form => {
      const upgradeSelect = form.querySelector('[data-cr-upgrade-variant]');
      if (upgradeSelect) {
        upgradeSelect.addEventListener('change', () => {
          form.querySelector('button[type="submit"]').disabled = upgradeSelect.selectedOptions[0].dataset.available !== 'true';
        }, { signal });
      }
      form.addEventListener('submit', event => {
        event.preventDefault();
        if (form.dataset.crBusy === 'true') return;
        const fields = new FormData(form);
        const variantId = Number(fields.get('id'));
        const quantity = Number(fields.get('quantity') || 1);
        if (!variantId || !quantity) return;
        const status = form.querySelector('[data-cr-form-status]');
        const button = event.submitter || form.querySelector('button[type="submit"]');
        if (button?.disabled) return;
        form.dataset.crBusy = 'true';
        if (status) { status.textContent = window.clownI18n.message_0; status.classList.remove('is-error'); }
        const settle = () => { delete form.dataset.crBusy; };
        document.dispatchEvent(new CustomEvent('clown:cart:add', { detail: {
          items: [{ id: variantId, quantity }], button,
          onSuccess: () => { settle(); if (status) status.textContent = window.clownI18n.message_23; },
          onError: (error) => { settle(); if (status) { status.classList.add('is-error'); status.textContent = error?.description || error?.message || window.clownI18n.message_4; } },
        } }));
      }, { signal });
    });

    /* ---------- Lecteurs (vidéo de démonstration si fournie) ---------- */
    root.querySelectorAll('[data-cr-player]').forEach(player => {
      const play = player.querySelector('[data-cr-play]');
      const tpl = player.querySelector('template[data-cr-player-video]');
      if (!play || !tpl) return;
      play.addEventListener('click', () => {
        if (player.querySelector(':scope > video')) return;
        const video = tpl.content.querySelector('video')?.cloneNode(true);
        if (!video) return;
        player.append(video);
        play.remove();
        const bar = player.closest('.cr-pdp-player')?.querySelector('[data-cr-player-progress]');
        if (bar) video.addEventListener('timeupdate', () => { if (video.duration) bar.style.setProperty('--p', `${(video.currentTime / video.duration) * 100}%`); }, { signal });
        video.play().catch(() => {});
        video.focus();
      }, { signal, once: true });
    });

    /* ---------- Illustration animée de la clôture ---------- */
    const drawing = root.querySelector('video[data-cr-drawing]');
    if (drawing && !reduced() && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(([entry]) => {
        if (!entry.isIntersecting) { if (!drawing.paused) drawing.pause(); return; }
        if (!drawing.src) { const apple = navigator.vendor === 'Apple Computer, Inc.'; const alpha = apple ? drawing.dataset.srcHevc : drawing.dataset.srcWebm; if (alpha) drawing.classList.add('is-alpha'); drawing.src = alpha || drawing.dataset.src; drawing.load(); }
        drawing.play().then(() => { drawing.hidden = false; drawing.parentElement.classList.add('is-playing'); }).catch(() => {});
      }, { threshold: 0.25 });
      io.observe(drawing.parentElement);
      signal.addEventListener('abort', () => io.disconnect());
    }

    /* ---------- Agrandissement ---------- */
    const dialog = root.querySelector('[data-cr-lightbox]');
    let opener;
    root.querySelectorAll('[data-cr-zoom]').forEach(button => button.addEventListener('click', () => {
      if (stage?.dataset.crSwiped) { delete stage.dataset.crSwiped; return; }
      if (!dialog?.showModal) return;
      opener = button;
      const source = button.querySelector('img');
      const target = dialog.querySelector('img');
      target.src = source.currentSrc || source.src; target.alt = source.alt;
      dialog.showModal();
    }, { signal }));
    dialog?.querySelector('[data-cr-close]')?.addEventListener('click', () => dialog.close(), { signal });
    dialog?.addEventListener('click', e => { if (e.target === dialog) dialog.close(); }, { signal });
    dialog?.addEventListener('close', () => opener?.focus(), { signal });

    /* ---------- Barre fixe d'ajout (tous écrans) : visible une fois le bouton principal dépassé, masquée sur la clôture ---------- */
    const sticky = root.querySelector('[data-cr-sticky]');
    const anchor = mainForm.querySelector('.cr-pdp__cta') || mainForm;
    const finalSection = root.querySelector('.cr-pdp-final');
    let ticking = false;
    const updateSticky = () => {
      ticking = false;
      if (!sticky) return;
      // N'apparaît qu'une fois le bouton principal dépassé (hero passé), jamais au chargement en haut de page.
      const pastCta = anchor.getBoundingClientRect().bottom < 0;
      const atFinal = finalSection ? finalSection.getBoundingClientRect().top < innerHeight * 0.8 : false;
      const show = pastCta && !atFinal;
      if (sticky.hidden === show) sticky.hidden = !show;
    };
    const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(updateSticky); } };
    addEventListener('scroll', onScroll, { passive: true, signal });
    addEventListener('resize', onScroll, { passive: true, signal });
    updateSticky();

    document.addEventListener('shopify:section:unload', e => { if (root.closest('.shopify-section')?.id?.endsWith(e.detail.sectionId)) abort.abort(); }, { signal });
    sync();
  };

  const boot = (scope = document) => scope.querySelectorAll('[data-cr-pdp]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(), { once: true }); else boot();
  if (!window.__clownProductSectionListener) {
    document.addEventListener('shopify:section:load', e => boot(e.target));
    window.__clownProductSectionListener = true;
  }
})();
